import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

import courierSrc from './assets/courier.svg'

const BASE_SIZE = 48

export const classes = {
  root: css`
    inline-size: ${BASE_SIZE}px;
    transform-origin: 0 0;
  `,
  defaultCourier: css`
    background: url(${courierSrc}) no-repeat;
    background-size: contain;
    inline-size: 123px;
    block-size: 104px;
  `,
  tooltip: css`
    margin-block-end: ${spacing(-3)} !important;
    white-space: pre;
    min-block-size: auto;
  `,
}
